import Collection from "../generic/collection";
import {FetchData} from "../utils/fetchData";
import Preloader from "../preloader";

export const instance = '[data-file-attacher]';

export class FileAttach {
  instance = instance;
  input = '[data-file-attacher-input]';
  addBtn = '[data-file-attacher-add-btn]';
  fileList = '[data-file-attacher-file-list]';

  files = [];

  constructor(instance) {
    this.instance = instance;
    this.$instance = $(instance);
    this.$addBtn = $(instance).find(this.addBtn);
    this.$input = $(instance).find(this.input);
    this.$fileList = $(instance).find(this.fileList);

    this.isMultiple = this.$input[0].hasAttribute('multiple');

    this.bindEvents();
  }

  attach() {
    const input = this.$input[0];
    const maxSize = JSON.parse(this.instance.dataset.fileAttacher).hasOwnProperty('size') ? JSON.parse(this.instance.dataset.fileAttacher).size : 100

    if (!this.isMultiple) {
      this.clear();
    }

    for (let i = 0; i < input.files.length; i++) {
      const file = input.files[i];
      const index = this.files.length
          ? this.files[this.files.length - 1].index + 1
          : 0
      ;
      if (!FileAttach.checkFile(input.accept,file)){
        const itemTpl = FileAttach.fileTemplate({
          name: 'Недопустимый формат файла',
          size: '',
          index
        });
        this.$fileList.append(itemTpl);
        setTimeout(()=> {
          this.$fileList[0].innerHTML = ''
        },1500)
        return false
      }
      const data = {
        name: file.name,
        size: FileAttach.bytesToSize(file.size),
        index
      };

      if (typeof (maxSize) === 'number' && Number(data.size.mB) > maxSize){
        data.name = `Максимальный размер файла ${maxSize} Мб`
        data.size = ''
      }else {
        data.size = data.size.formatDate
      }

      if (!this.files.find(file => file.file.name === data.name)) {
        const itemTpl = FileAttach.fileTemplate(data);

        this.files.push({
          index,
          file
        });

        this.$fileList.append(itemTpl);
      }
    }
  }

  static checkFile(acceptExt, {name}) {
    let extensionsArray = acceptExt.split(','),
        formatFileName = [],
        accessFlag = false;

    formatFileName = name.split('.');

    extensionsArray = extensionsArray.map(el=> {
      let elWithOutSpace = el.trim();
      return  elWithOutSpace.replace('.', '');
    })

    extensionsArray.forEach( ext => {
      let reg = new RegExp(ext)
      if (reg.test(formatFileName[formatFileName.length - 1])) {
        accessFlag = true
      }
    })

    return accessFlag;
  }

  static fileTemplate({name, size, index}) {
    /* default template
    * <li class="file-attacher__list-item" data-file-attacher-file="${index}">
              <div class="file-attacher__list-item-name">${name}</div>
              <span class="file-attacher__list-item-size">${size}</span>
              <a href="#" class="file-attacher__list-item-remove" data-file-attacher-file-remove>Удалить</a>
          </li>
    */
    return `
          <li class="file-attacher__list-item" data-file-attacher-file="${index}">
              <div class="file-attacher__list-item-name">${name}</div>
              <span class="file-attacher__list-item-size">${size}</span>
          </li>
      `;
  }

  removeFile(index) {
    const $file = this.$fileList.find(`[data-file-attacher-file="${index}"]`);
    $file.remove();

    const inArrIndex = this.files.findIndex((el) => el.index === Number(index));
    this.files.splice(inArrIndex, 1);

    if (!this.files.length) {
      this.$fileList.html('');
    }
    this.$input.val('');
  }

  clear() {
    this.files = [];
    this.$fileList.html('');

    if (this.isMultiple) {
      this.$input.val('');
    }
  }

  async dellFile(ajaxUrl, index, confirmText){
    if (confirm(confirmText)) {
      let request = await FetchData.postData({data: $(this.$input).attr('id')}, ajaxUrl)
      Preloader.hide()
      if (request.success) {
        this.removeFile(index);
      }
    }
  }

  static bytesToSize(bytes) {
    const sizes = ['Байт', 'Кб', 'Мб', 'Гб', 'Тб'];
    bytes = Number(bytes);

    if (bytes === 0) {
      return '0 Байт';
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return {formatDate:Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i], mB: Math.floor(bytes / (1024 * 1024))  };
  }

  bindEvents() {
    $(this.$input).on('change', () => {
      this.attach();
    });

    $(this.$instance).on('click', (e) => {
      if ($(e.target)[0].hasAttribute('data-file-attacher-file-remove')) {
        e.preventDefault();
        const index = $(e.target).closest('[data-file-attacher-file]').attr('data-file-attacher-file');
        this.dellFile($(e.target).attr('data-file-attacher-file-remove'), index, $(e.target).attr('data-js-confirm'))
      } else if(e.target.closest('[data-file-attacher-file-list]')){
        e.target.closest('[data-file-attacher]').querySelector('input').click()
      }
    });

  }
}

export class FileAttachCollection extends Collection {
  constructor() {
    super(instance, FileAttach);

    this.init();
    this.bindEvents();
  }

  init() {
    $(instance).each((index, el) => {
      this.collection = new FileAttach(el)
    });
  }

  bindEvents() {}
}